"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var useChildRef = function useChildRef(children) {
  // Verifies that children has only one child (a React element) and returns it.
  var childElement = _react["default"].Children.only(children);

  var triggerRef = (0, _react.useRef)(); // Pass ref

  var child = /*#__PURE__*/(0, _react.cloneElement)(childElement, {
    ref: function ref(node) {
      triggerRef.current = node; // Pass the original ref for childElement, so it can access the ref too

      var ref = children.ref;

      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    }
  });
  return {
    child: child,
    triggerRef: triggerRef
  };
};

var _default = useChildRef;
exports["default"] = _default;
//# sourceMappingURL=useChildRef.js.map